
export default class homeHeroTextSlider
{
    constructor ()
    {
        var $sliderContainer = $('.slider-container-js');

        if (!$sliderContainer.length) {
            return;
        }

        var timeBetweenSlides = 11000;
        var $slides = $sliderContainer.find('.slide-js');
        var $dots   = $sliderContainer.find('.dot-js');

        if ($slides.length === 1) {
            // if only 1 slide, no need for functionality
            return;
        }

        $dots.on('click keydown', function (e) {
            // on click, enter, or space
            if (e.type === 'click' || (e.type === 'keydown' && (pressed === 13 || pressed === 32))) {
                changeSlide($(e.currentTarget));
            }
        });

        function changeSlide($targetDot)
        {
            if ($targetDot.hasClass('active')) {
                return;
            }

            $slides.removeClass('active');
            $dots.removeClass('active');

            $targetDot.addClass('active');
            $($slides.get(
                Number($targetDot.attr('data-index'))
            )).addClass('active');

            setTimeout(function () {
                changeSlide(fetchNext())
            }, timeBetweenSlides);
        }

        function fetchNext()
        {
            var $current = $sliderContainer.find('.dot-js.active');
            var $next = $current.next();

            if (!$next.length) {
                $next = $($dots.get(0));
            }

            return $next;
        }

        setTimeout(function () {
            changeSlide(fetchNext())
        }, timeBetweenSlides);
    }
}
